module.exports = __webpack_public_path__ + "img/aleve_liquid_gels.fd2d96ac.png";